export default __webpack_public_path__ + "static/media/laundry2-afterB-1024w.bc48d7db.png";